"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var BedOutline = function BedOutline(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "36",
    height: "30",
    viewBox: "0 0 36 30"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    stroke: fill,
    strokeWidth: "2.1875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.91667 14.0312H31.8958C32.6694 14.0312 33.4112 14.3385 33.9582 14.8855C34.5052 15.4325 34.8125 16.1744 34.8125 16.9479V23.875H2V16.9479C2 16.1744 2.30729 15.4325 2.85427 14.8855C3.40125 14.3385 4.14312 14.0312 4.91667 14.0312V14.0312Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 23.875V28.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.8125 23.875V28.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.5313 14.0313V4.1875C31.5313 3.60734 31.3008 3.05094 30.8905 2.6407C30.4803 2.23047 29.9239 2 29.3438 2H7.46875C6.88859 2 6.33219 2.23047 5.92195 2.6407C5.51172 3.05094 5.28125 3.60734 5.28125 4.1875V14.0313"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.3021 8.5625H23.5104C23.8972 8.5625 24.2681 8.71615 24.5416 8.98964C24.8151 9.26313 24.9688 9.63406 24.9688 10.0208V14.0313H11.8438V10.0208C11.8438 9.63406 11.9974 9.26313 12.2709 8.98964C12.5444 8.71615 12.9153 8.5625 13.3021 8.5625V8.5625Z"
  })));
};
BedOutline.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
BedOutline.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = BedOutline;